import * as React from 'react';
import { ILogoProps } from './Ilogo.component';
import styles from './logo.module.scss';
import { Col, Row } from 'reactstrap';

const Logo: React.FC<ILogoProps> = (props) => {

    return (
        <div className={styles.Logo}>
            <Row className="text-left">
                <Col 
                xs={4}
                md={12}>
                    <img src={props.logoUrl} className="img-fluid" />
                </Col>
                <Col className="d-inline-block d-md-none">
                    <h6 className="mt-1 mb-0 text-center">PROYECTA</h6>
                </Col>
            </Row>
        </div>
    );
};
export default Logo;